import { useQuery } from '../useQuery';
import { useMutation } from '../useMutation';
import {
  CREATE_OFFICE_CITY_ADMIN,
  DELETE_OFFICE_CITY_ADMIN,
  GET_OFFICE_CITY_ADMIN,
  LIST_OFFICES_CITIES_ADMIN,
  LIST_OFFICES_CITIES_ADMIN_PAGINATED,
  UPDATE_OFFICE_CITY_ADMIN
} from './graphql/queries';

/** @format */
export const useOfficesCities = () => {
  const { getDataGQL: listOfficesCitiesAdmin } = useQuery(LIST_OFFICES_CITIES_ADMIN);
  const { getDataGQL: listOfficesCitiesAdminPaginated } = useQuery(LIST_OFFICES_CITIES_ADMIN_PAGINATED);
  const { getDataGQL: getOfficeCityAdmin } = useMutation(GET_OFFICE_CITY_ADMIN);
  const { getDataGQL: createOfficeCityAdmin } = useMutation(CREATE_OFFICE_CITY_ADMIN);
  const { getDataGQL: updateOfficeCityAdmin } = useMutation(UPDATE_OFFICE_CITY_ADMIN);
  const { getDataGQL: deleteOfficeCityAdmin } = useMutation(DELETE_OFFICE_CITY_ADMIN);

  const onListOfficesCitiesAdmin = async () => {
    const response = await listOfficesCitiesAdmin();
    if (response?.adminRoute?.listOfficesCitiesAdmin) {
      return response?.adminRoute?.listOfficesCitiesAdmin;
    }
    return null;
  };

  const onListOfficesCitiesAdminPaginated = async ({ filters }) => {
    const response = await listOfficesCitiesAdminPaginated({
      variables: {
        filters
      }
    });
    if (response?.adminRoute?.listOfficesCitiesAdminPaginated) {
      return response?.adminRoute?.listOfficesCitiesAdminPaginated;
    }
    return null;
  };

  const onGetOfficeCityAdmin = async ({ office_city_id }) => {
    const response = await getOfficeCityAdmin({
      variables: {
        office_city_id
      }
    });
    if (response?.adminRoute?.getOfficeCityAdmin) {
      return response?.adminRoute?.getOfficeCityAdmin;
    }
    return null;
  };

  const onCreateOfficeCityAdmin = async ({ office_city_data }) => {
    const response = await createOfficeCityAdmin({
      variables: {
        office_city_data
      }
    });
    if (response?.adminRoute?.createOfficeCityAdmin) {
      return response?.adminRoute?.createOfficeCityAdmin;
    }
    return null;
  };

  const onUpdateOfficeCityAdmin = async ({ office_city_id, office_city_data }) => {
    const response = await updateOfficeCityAdmin({
      variables: {
        office_city_id,
        office_city_data
      }
    });
    if (response?.adminRoute?.updateOfficeCityAdmin) {
      return response?.adminRoute?.updateOfficeCityAdmin;
    }
    return null;
  };

  const onDeleteOfficeCityAdmin = async ({ office_city_id }) => {
    const response = await deleteOfficeCityAdmin({
      variables: {
        office_city_id
      }
    });
    if (response?.adminRoute?.deleteOfficeCityAdmin) {
      return response?.adminRoute?.deleteOfficeCityAdmin;
    }
    return null;
  };

  return {
    onListOfficesCitiesAdmin,
    onListOfficesCitiesAdminPaginated,
    onGetOfficeCityAdmin,
    onCreateOfficeCityAdmin,
    onUpdateOfficeCityAdmin,
    onDeleteOfficeCityAdmin
  };
};
